export default __webpack_public_path__ + "static/media/icons-fail.86274249.svg";